import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { AuftragAnmerkungenPage } from '../../auftrag-anmerkungen/auftrag-anmerkungen.page';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-anmerkungen-komponente',
    template: `
        <div class="section ion-activatable" appClick (clicked)="onAnmerkungenBearbeiten()">
        <h1 *ngIf="getEinstellung('Titel')">{{ getEinstellung('Titel') }}</h1>

        <div class="anmerkungen-container" [class.anmerkungen-vorhanden]="auftrag.Anmerkungen">
            <span *ngIf="!auftrag.Anmerkungen">Zum Bearbeiten hier tippen.</span>
            <span *ngIf="auftrag.Anmerkungen">{{ auftrag.Anmerkungen }}</span>
        </div>
        </div>
    `,
    styles: [`
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragAnmerkungenComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        private modalController: ModalController,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    async onAnmerkungenBearbeiten() {
        this.auftragdetails.anzeigenAnmerkungen();
    }
}
